import { render, staticRenderFns } from "./AdminForm.vue?vue&type=template&id=24b03df1"
import script from "./AdminForm.vue?vue&type=script&lang=ts"
export * from "./AdminForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports